<template>
    <section class="col-12 px-0 h-100">
        <img alt="" class="picto-add" :src="iconPlus">
        <div class="container mw-100 border-gray div-img h-100 recommended-internet-tile mb-0">
            <div class="row h-100 px-0">
                <div class="col-12 px-0">
                    <div class="row px-1">
                        <!--/* BANNIERE + TIMER */-->
                        <section class="pb-2">
                            <div v-if="offer.banner" class="col-12">
                                <div class="row align-items-center reco-banner">
                                    <!--/* BANNER */-->
                                    <div class="col-auto p-0 padding-bottom-banner">
                                        <div class="ob1-tag ob1-tag-primary">
                                            <span>{{ offer.banner }}</span>
                                        </div>
                                    </div>
                                    <!--/* TIMER */-->
                                    <div v-if="offer.timerEndDateInMilliseconds" class="col-auto p-0 padding-left-tag padding-bottom-banner">
                                        <timer
                                            :end-date-in-milliseconds="offer.timerEndDateInMilliseconds"
                                            :color="offer.countDownColor ? offer.countDownColor : 'text-dark'"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div v-else class="col-12 reco-banner" />
                        </section>

                        <div class="col-12 pb-1 text-center">
                            <div class="reco-title text-primary pb-0 mb-0">
                                <h2 class="h4">
                                    {{ offer.name }}
                                </h2>
                            </div>
                        </div>

                        <div class="col-12 pb-2 d-flex justify-content-center">
                            <a
                                :href="offer.foLink"
                                class="ob1-link-arrow"
                                :data-oevent-category="offer.foHighlightTms.category"
                                :data-oevent-action="offer.foHighlightTms.action"
                                :data-oevent-label="offer.foHighlightTms.label"
                            >{{ offer.foLinkLabel }}</a>
                        </div>

                        <div class="col-12 py-0 text-center">
                            <hr class="separator separator--gray4 my-0">
                        </div>

                        <!--/* PRICE */-->
                        <div class="col-12 pt-1 text-center">
                            <Price
                                :custom="'reco-ob1-price h3 text-dark'"
                                :price="offer.price.price"
                                :initial-price="offer.price.initialPrice"
                                :price-details="offer.price.priceDetails ? offer.price.priceDetails : undefined"
                                :show-from="offer.price.showFrom"
                                :show-by-month="offer.price.showByMonth"
                                :show-promo-duration="offer.price.showPromoDuration"
                                :duration="offer.price.duration"
                                :is-cents-format="false"
                                :is-mini="offer.price.mini"
                            />
                        </div>
                        <div class="col-12 pb-2 text-center">
                            <strong>{{ offer.commitment }}</strong>
                        </div>

                        <!--/* CLAIMS */-->
                        <div class="col-12 text-center px-0" :class="offerClaimsClass">
                            <div class="reco-claim">
                                <div v-if="firstClaimWithImage">
                                    <div class="py-1 px-1" :class="offer.claimBgColor">
                                        <div>
                                            <img
                                                class="reco-internet-claim-img"
                                                loading="lazy"
                                                :src="firstClaimWithImage.image.url"
                                                :alt="firstClaimWithImage.image.alt"
                                            >
                                        </div>
                                        <div v-for="attribute in firstClaimWithImage.attributes">
                                            <p class="mb-0 px-2 d-flex align-items-center justify-content-center">
                                                <span v-html="attribute.textHtml" />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Price from "../../../../../../common/components/ob1/Price.vue";

export default {
    name: "RecommendedInternetOfferTile",
    components: {Price},
    props: {
        offer: {type: Object, required: true},
        iconPlus: {type: String, required: true}
    },
    computed: {
        firstClaimWithImage() {
            return this.offer.claims.find(claim => claim.image) || null;
        },
        offerClaimsClass() {
            let returnedBgClass = 'bg-white';
            if ( this.offer && this.offer.claimBgColor && this.firstClaimWithImage ) {
                returnedBgClass = this.offer.claimBgColor
            }
            return returnedBgClass;
        }
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.border-gray {
    border: px-to-rem(2) solid $gray-lighter;
}

$ice: #ebfcee;

.bg-ice {
    background-color: $ice
}

.picto-add {
    position: absolute;
    top: 45%;
    left: -40px;
    height: 50px;
    z-index: 200;
}

.div-img {
    position: relative;
}

.padding-bottom-banner {
    padding-bottom: 5px !important;
}

.padding-left-tag {
    padding-left: 10px !important;
}

.reco-internet-claim-img {
    height: 40px;
    max-width: 80%;
}

</style>
